
import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { Image } from 'react-bootstrap';
import { APPOINMENT_API, BaseGatewayImage } from '@app/utils/apiUrl';
import { DeleteSingle, DeleteMultiple, Get, Put } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../utils/helper';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { objectShowNumber, messageToast, objectDataTypeBooking, dataTypeBooking } from '../../../utils/define';
import { ConfirmModal } from '../../../modules/modal/ConfirmModal';
import * as moment from 'moment';
import { mapToAppointment } from "../../../models/appoinmentModels"; // Import model


/**
 * @typedef {Object} Appointment
 * @property {string} id
 * @property {string} dateBooking
 * @property {string} email
 * @property {string} locationName
 * @property {string} name
 * @property {string} note
 * @property {string} phone
 * @property {string} status
 * @property {string} time
 */


const Appoinment = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [selectedItems, setSelectedItems] = useState([]);
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);

    const deleteFuncMutil = useMutation((ids) =>
        DeleteMultiple(APPOINMENT_API.DELETE, ids)
    );

    const updateFunc = useMutation(({ id, modelUpdate }) =>
        Put(APPOINMENT_API.UPDATE, id, modelUpdate)
    );


    const { isLoading, isError, error, data, refetch } = useQuery(
        ['appoinment', valueSearch, page, pageSize],
        async () => {
            const response = await Get(APPOINMENT_API.GET_ALL_PAGING, null, {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize
            });
            // console.log("response",response)
            // /** @type {Appointment[]} */
            // const appointments = response?.data?.$values?.map(mapToAppointment) || [];
            // return appointments;
            // /** @type {Appointment[]} */
            // return response?.data?.$values || [];
            return response;
        }
    );
    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
    };

    const changePage = (number) => {
        setPage(number);
    };


    // Thực hiện xóa nhiều item

    // Xử lý khi chọn/bỏ chọn một mục
    const handleSelectItem = (id) => {
        setSelectedItems((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((item) => item !== id) // Bỏ chọn
                : [...prevSelected, id] // Chọn thêm
        );
    };

    // Xử lý khi chọn/bỏ chọn tất cả
    const handleSelectAll = () => {
        if (selectedItems.length === data?.data?.$values?.length) {
            setSelectedItems([]); // Nếu đã chọn hết thì bỏ chọn
        } else {
            setSelectedItems(data?.data?.$values?.map((item) => item.id) || []); // Chọn tất cả
        }
    };


    // Gọi API để xóa các mục đã chọn
    const handleDeleteSelected = async () => {
        if (selectedItems.length === 0) {
            toast.warning("Vui lòng chọn ít nhất một mục để xóa!");
            return;
        }
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        try {
            //  Cách 1 xóa gọi API trực tiếp
            // await DeleteMultiple(APPOINMENT_API.DELETE, selectedItems);
            // toast.success("Xóa thành công!");
            // setSelectedItems([]); // Xóa xong thì reset danh sách đã chọn
            // refetch(); // Refresh danh sách

            // Cách 2 thông qua useQuery
            if (selectedItems.length > 0) {
                deleteFuncMutil.mutate(selectedItems, {
                    onSuccess: (res) => {
                        if (res.status === 201 || res.status === 200) {
                            toast.success(messageToast.messageToastDeleteSuccess);
                            setSelectedItems([]);
                            refetch();
                        } else {
                            toast.error(messageToast.messageToastDeleteError);
                        }
                    },
                    onError: (res) => {
                        toast.error(messageToast.messageToastTryCatch);
                    }
                });
            }
        } catch (error) {
            toast.error("Có lỗi xảy ra khi xóa!");
        }
        setOpenConfirmDeleteModal(false);
    };

    const cancelDelete = () => {
        setOpenConfirmDeleteModal(false);
    };

    const handleStatusChange = (id, newStatus) => {
        try {
            if (id && newStatus) {
                let modelUpdate = { status: newStatus };
                updateFunc.mutate({ id, modelUpdate }, {
                    onSuccess: (res) => {
                        if (res.status === 201 || res.status === 200) {
                            toast.success("Cập nhật dữ liệu thành công");
                            setSelectedItems([]);
                            refetch();
                        } else {
                            toast.error("Cập nhật dữ liệu thất bại");
                        }
                    },
                    onError: (res) => {
                        toast.error("Có lỗi xảy ra khi cập nhật dữ liệu!");
                    }
                });
            }
        }
        catch (error) {
            toast.error("Có lỗi xảy ra khi cập nhật dữ liệu!");
        }
    };


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title"> Danh sách booking</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between" style={{marginBottom:'10px'}}>
                                <form className="form-inline">
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2"
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </form>
                            </div>
                            {isLoading ? (
                                <div>Loading...</div>
                            ) : isError ? (
                                <div>
                                    An error has occurred: ${error.message}
                                </div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                >
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr role="row">
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                onChange={handleSelectAll}
                                                                checked={
                                                                    selectedItems.length ===
                                                                    data?.data?.$values?.length
                                                                }
                                                            />
                                                        </th>
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Tên
                                                        </th>
                                                        <th className="sorting">
                                                            Phone
                                                        </th>
                                                        <th className="sorting">
                                                            Email
                                                        </th>
                                                        <th className="sorting">
                                                            Ghi chú
                                                        </th>
                                                        <th className="sorting">
                                                            Cơ sở
                                                        </th>
                                                        <th className="sorting">
                                                            Ngày
                                                        </th>
                                                        <th className="sorting">
                                                            Thời gian
                                                        </th>
                                                        <th className="sorting">
                                                            Trạng thái
                                                        </th>
                                                        {/* <th className="sorting">
                                                            Hành động
                                                        </th> */}
                                                    </tr>
                                                </thead>
                                                {data?.data?.$values && data?.data?.$values.length > 0 ? (
                                                    <tbody>
                                                        {data?.data?.$values.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedItems.includes(item.id)}
                                                                            onChange={() => handleSelectItem(item.id)}
                                                                        />
                                                                    </td>
                                                                    <td className="dtr-control sorting_1">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                            pageSize}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.name
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.phone
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.email
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.note
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.locationName
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            moment(new Date(item.dateBooking)).format('DD/MM/YYYY')
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.time
                                                                        }
                                                                    </td>
                                                                    <td >
                                                                        {/* {
                                                                            objectDataTypeBooking.find(x => x.value == item.status).label
                                                                        } */}

                                                                        <select
                                                                            style={{ color: item.status == dataTypeBooking.confirm ? 'blue' : item.status == dataTypeBooking.pending ? "orange" : 'red' }}
                                                                            value={item.status}
                                                                            onChange={(e) => handleStatusChange(item.id, e.target.value)}
                                                                        >
                                                                            {objectDataTypeBooking.map((option) => (
                                                                                <option key={option.value} value={option.value}>
                                                                                    {option.label}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </td>


                                                                    {/* <td>
                                                                        <div
                                                                            className={
                                                                                item.isActive
                                                                                    ? 'icheck-primary'
                                                                                    : 'icheck-danger'
                                                                            }
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                id={
                                                                                    item.id
                                                                                }
                                                                                name={
                                                                                    item.id
                                                                                }
                                                                                defaultChecked
                                                                            />
                                                                            <label
                                                                                htmlFor={
                                                                                    item.id
                                                                                }
                                                                            >
                                                                                {item.isActive
                                                                                    ? 'Đã kích hoạt'
                                                                                    : 'Chưa kích hoạt'}
                                                                            </label>
                                                                        </div>
                                                                    </td> */}
                                                                    {/* <td>
                                                                        <ul className="nav">
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    to={createUrlWithParam(
                                                                                        URI_INTERNAL.PARTNER_EDIT_PATH,
                                                                                        {
                                                                                            id: item.id
                                                                                        }
                                                                                    )}
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Sửa"
                                                                                        className="nav-icon font-icon fas fa-pen"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    onClick={() =>
                                                                                        deleteAction(
                                                                                            item.id,
                                                                                            item.name
                                                                                        )
                                                                                    }
                                                                                    to
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Xóa"
                                                                                        className="nav-icon font-icon far fa-trash-alt"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                        </ul>
                                                                    </td> */}
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr className="txt-center">
                                                            <td colSpan="12">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}

                                            </Table>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="d-flex justify-content-between mt-3">
                                            <button
                                                className="btn btn-danger"
                                                onClick={handleDeleteSelected}
                                                disabled={selectedItems.length === 0}
                                            >
                                                Xóa đã chọn
                                            </button>
                                        </div>
                                        <div className="col-sm-12">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="example2_paginate"
                                            >
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass="pagination pagination-sm no-margin pull-right"
                                                    activePage={page}
                                                    itemsCountPerPage={Number(
                                                        pageSize
                                                    )}
                                                    totalItemsCount={
                                                        data?.totalRecords
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(number) =>
                                                        changePage(number)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            )}
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                            // content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Appoinment